export default "assets/images/icons/download-b77068a0.svg";